
<mat-dialog-content>
    
        <mat-card>
            <mat-card-title class="font-weight-bold caption-color">Notional Rent Details</mat-card-title>
            <mat-divider></mat-divider>            
            <mat-card-content>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group row text-left ">
                            <label class="col-sm-2 col-form-label  pl-4 font-20">
                                Calculated Rent
                            </label>
                            <div class="col-sm-2 pl-4 font-16 pt-2">
                                {{this.NotionalInput.Rent  | number : '1.2-2'}}
                            </div>
                        </div>
                    
                    </div>                    
            </div>

                <div class="row">
                    <div class="col-sm-12">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Copy</th>
                            <th>Rate</th>
                            <th>Commitment</th>                             
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of NotionalInput.CounterDetail; let i = index;">
                                <td>  
                                       {{item.CounterDesc}}
                                </td>
                                <td> 
                                     <input type="number" [disabled]="FromView" name="txtRate" (input)="RateCommitmentChange()"  [(ngModel)]="item.Rate" class="form-control" >
                                    </td>
                                <td>  
                                    <input type="number" [disabled]="FromView" name="txtCommitment" (input)="RateCommitmentChange()" [(ngModel)]="item.Commitment" class="form-control" >
                                </td>
                      
                                        
                        </tr>
        
                        </tbody>
                        </table>
    
    
                        </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-sm-12">
                                <mat-divider></mat-divider>
                            </div>
                            <div class="col-sm-12 text-right mt-2 mb-2" *ngIf="!FromView">
                                <button type="button" class="btn btn-primary" (click)="Close()">Submit</button>
                            </div>
                        </div>
                        
                        
            </mat-card-content>
    
    
    </mat-card> 
    </mat-dialog-content>